export var EClientType;
(function (EClientType) {
    EClientType["Broker"] = "BROKER";
    // cspell:ignore PATRIMONYCOMPANY
    EClientType["PatrimonyCompany"] = "PATRIMONYCOMPANY";
    EClientType["Partner"] = "PARTNER";
})(EClientType || (EClientType = {}));
export var EIntakeType;
(function (EIntakeType) {
    EIntakeType[EIntakeType["TwoPhases"] = 1] = "TwoPhases";
    EIntakeType[EIntakeType["OnePhase"] = 2] = "OnePhase";
    EIntakeType[EIntakeType["TwoPhasesWithVisit"] = 3] = "TwoPhasesWithVisit";
})(EIntakeType || (EIntakeType = {}));
export var EBrokerFeature;
(function (EBrokerFeature) {
    EBrokerFeature["Bookkeeping"] = "BOOKKEEPING";
    EBrokerFeature["CompleteContractFlow"] = "COMPLETE_CONTRACT_FLOW";
    EBrokerFeature["DuplicateContacts"] = "DUPLICATE_CONTACTS";
    EBrokerFeature["EnableBanqup"] = "ENABLE_BANQUP";
    EBrokerFeature["EnableLinkingProperties"] = "ENABLE_LINKING_PROPERTIES";
    EBrokerFeature["Ibanisation"] = "IBANISATION";
    EBrokerFeature["Insurance"] = "INSURANCE";
    EBrokerFeature["IntakeIncludeIncomeStatement"] = "INTAKE_INCLUDE_INCOME_STATEMENT";
    EBrokerFeature["IntakeIncomeOptional"] = "INTAKE_INCOME_OPTIONAL";
    EBrokerFeature["Invoicing"] = "INVOICING";
    EBrokerFeature["PaymentV2"] = "PAYMENT_V2";
    EBrokerFeature["PropertyInspectionReport"] = "PROPERTY_INSPECTION_REPORT";
    EBrokerFeature["RentDiscount"] = "RENT_DISCOUNT";
    EBrokerFeature["RentioLegal"] = "RENTIO_LEGAL";
    EBrokerFeature["RentioMove"] = "RENTIO_MOVE";
    EBrokerFeature["TenantEndingNotification"] = "TENANT_ENDING_NOTIFICATION";
})(EBrokerFeature || (EBrokerFeature = {}));
export var EBrokerUsageStatus;
(function (EBrokerUsageStatus) {
    EBrokerUsageStatus["Green"] = "green";
    EBrokerUsageStatus["Orange"] = "orange";
    EBrokerUsageStatus["Red"] = "red";
})(EBrokerUsageStatus || (EBrokerUsageStatus = {}));
export var EBrokerBookkeepingSyncType;
(function (EBrokerBookkeepingSyncType) {
    EBrokerBookkeepingSyncType["Charge"] = "CHARGE";
    EBrokerBookkeepingSyncType["Payout"] = "PAYOUT";
})(EBrokerBookkeepingSyncType || (EBrokerBookkeepingSyncType = {}));
export var EIntegratorIds;
(function (EIntegratorIds) {
    EIntegratorIds["Dewaele"] = "1";
    EIntegratorIds["Zabun"] = "2";
    EIntegratorIds["EraForce"] = "3";
    EIntegratorIds["ImmoZone"] = "4";
    EIntegratorIds["Rentio"] = "5";
})(EIntegratorIds || (EIntegratorIds = {}));
// cspell:disable
export var EBrokerScopes;
(function (EBrokerScopes) {
    EBrokerScopes["Dewaele"] = "crm:dewaele";
    EBrokerScopes["EraForce"] = "crm:eraforce";
    EBrokerScopes["Maximo"] = "crm:maximmo";
    EBrokerScopes["Omnicasa"] = "crm:omnicasa";
    EBrokerScopes["RealSuite"] = "crm:realsuite";
    EBrokerScopes["Skarabee"] = "crm:skarabee";
    EBrokerScopes["Sweepbright"] = "crm:sweepbright";
    EBrokerScopes["Whise"] = "crm:whise";
    EBrokerScopes["Zabun"] = "crm:zabun";
})(EBrokerScopes || (EBrokerScopes = {}));
// cspell:enable
